"use strict";

import { isDesktop } from "./helpers";

export class ScrollFilterManager {
  private selector: string = "data-kb-is-scroll-filter";
  private linkWidth: number = 40;

  constructor() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => {
        this.onContentLoaded();
      }, false);
    } else {
      this.onContentLoaded();
    }

    window.addEventListener("resize", () => {
      this.onContentLoaded();
    }, false);
  }

  private onContentLoaded(): void {
    const elements = document.querySelectorAll(`[${this.selector}]`);

    for (let i = 0; i < elements.length; i++) {
      let el = elements[i];

      let wrapper: HTMLElement = <HTMLElement>el.querySelector(".filters__wrapper");
      let links: HTMLElement = <HTMLElement>el.querySelector(".filters__links");
      let leftArrow: HTMLElement = <HTMLElement>el.querySelector(".filters__control--left");
      let rightArrow: HTMLElement = <HTMLElement>el.querySelector(".filters__control--right");

      if (wrapper === null
         || leftArrow === null
         || rightArrow === null
         || links === null) {
          return;
      }

      if (isDesktop()) {
        this.applyOffset(wrapper, 0);
        return;
      }

      let initialOffset = Number(wrapper.dataset.kbScrollOffset);
      this.applyOffset(wrapper, initialOffset);

      leftArrow.addEventListener("click", _ => {
        let offset = Number(wrapper.dataset.kbScrollOffset);
        if (offset <= 0) {
          return;
        }

        offset--;
        this.applyOffset(wrapper, offset);
      });

      rightArrow.addEventListener("click", _ => {
        let offset = Number(wrapper.dataset.kbScrollOffset);
        if (offset >= this.computeMaxOffset(wrapper, links)) {
          return;
        }

        offset++;
        this.applyOffset(wrapper, offset);
      });
    }
  }

  private applyOffset(el: HTMLElement, offset: number): void {
    el.dataset.kbScrollOffset = offset.toString();
    el.style.transform = `translateX(-${this.linkWidth * offset}px)`;
  }

  private computeMaxOffset(wrapper: HTMLElement, links: HTMLElement): number {
    const nbLinks = wrapper.querySelectorAll(".filters__link").length;
    const shownWidth = parseInt(getComputedStyle(links).width!);
    const maxShownLinks = shownWidth / this.linkWidth;
    return Math.ceil(nbLinks - maxShownLinks);
  }
}
